"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useWizardStepHandlers = exports.useWizardStepNavigate = void 0;
var react_1 = require("react");
var react_router_dom_1 = require("react-router-dom");
var components_1 = require("../components");
var core_1 = require("../core");
var useWizardStepNavigate = function () {
    var history = (0, react_router_dom_1.useHistory)();
    return (0, react_1.useCallback)(function (step, replace) {
        if (replace === void 0) { replace = false; }
        if (!step)
            return;
        if (typeof step === 'string') {
            var stepId = step;
            step = core_1.WizardStepRegistry.getStepById(stepId);
            if (!step) {
                throw new Error('Could not find step: ' + stepId);
            }
        }
        var stepUrl = step.getUrl();
        if (!stepUrl)
            return;
        if (replace) {
            history.replace(stepUrl);
        }
        else {
            history.push(stepUrl);
        }
    }, [history]);
};
exports.useWizardStepNavigate = useWizardStepNavigate;
var useWizardStepHandlers = function () {
    var step = (0, components_1.useWizardStepContext)().step;
    var goToStep = (0, exports.useWizardStepNavigate)();
    return (0, react_1.useMemo)(function () {
        var back = function () { return goToStep(step.getPreviousStep()); };
        var forward = function () { return goToStep(step.getNextStep()); };
        return { back: back, forward: forward };
    }, [goToStep, step]);
};
exports.useWizardStepHandlers = useWizardStepHandlers;
//# sourceMappingURL=hooks.js.map